import * as Cookie from './cookie';

export function editDesiredGftContainerOptions(small = false) {
    const containerRequestForm = document.querySelector('form[id^="container-request"]');

    if (small) {
        containerRequestForm.querySelector('[data-name="desired_gft_container"] option:nth-child(1)').classList.add('hidden');
        containerRequestForm.querySelector('[data-name="desired_gft_container"] option:nth-child(2)').classList.add('hidden');
        containerRequestForm.querySelector('[data-name="desired_gft_container"] option:nth-child(3)').classList.add('hidden');
        containerRequestForm.querySelector('[data-name="desired_gft_container"] option:nth-child(4)').classList.add('hidden');
    } else {
        containerRequestForm.querySelectorAll('[data-name="desired_gft_container"] option').forEach((el) => {
            el.classList.remove('hidden');
        });
    }
}

export function editDesiredRestContainerOptions(small = false) {
    const containerRequestForm = document.querySelector('form[id^="container-request"]');

    if (small) {
        containerRequestForm.querySelector('[data-name="desired_rest_container"] option:nth-child(1)').innerHTML = 'Selecteer de gewenste container inhoud';
        containerRequestForm.querySelector('[data-name="desired_rest_container"] option:nth-child(1)').classList.add('hidden');
        containerRequestForm.querySelector('[data-name="desired_rest_container"] option:nth-child(2)').classList.add('hidden');
        containerRequestForm.querySelector('[data-name="desired_rest_container"] option:nth-child(3)').classList.add('hidden');
        containerRequestForm.querySelector('[data-name="desired_rest_container"] option:nth-child(4)').classList.add('hidden');
        containerRequestForm.querySelector('[data-name="desired_rest_container"] option:nth-child(5)').classList.add('hidden');
    } else {
        containerRequestForm.querySelector('[data-name="desired_rest_container"] option:nth-child(1)').innerHTML = 'Deze hoeft niet gewisseld te worden';
        containerRequestForm.querySelectorAll('[data-name="desired_rest_container"] option').forEach((el) => {
            el.classList.remove('hidden');
        });
    }
}

export function editCurrentRestContainerOptions(small = false) {
    const containerRequestForm = document.querySelector('form[id^="container-request"]');

    if (small) {
        containerRequestForm.querySelector('[data-name="current_rest_container"] option:nth-child(1)').innerHTML = 'Selecteer je huidige container inhoud';
        containerRequestForm.querySelector('[data-name="current_rest_container"] option:nth-child(1)').classList.add('hidden');
        containerRequestForm.querySelector('[data-name="current_rest_container"] option:nth-child(7)').classList.add('hidden');
        containerRequestForm.querySelector('[data-name="current_rest_container"] option:nth-child(6)').classList.add('hidden');
    } else {
        containerRequestForm.querySelector('[data-name="current_rest_container"] option:nth-child(1)').innerHTML = 'Deze hoeft niet gewisseld te worden';
        containerRequestForm.querySelectorAll('[data-name="current_rest_container"] option').forEach((el) => {
            el.classList.remove('hidden');
        });
    }
}

export default function initContainerRequest() {
    window.addEventListener('DOMContentLoaded', () => {
        const containerRequestForm = document.querySelector('form[id^="container-request"]');

        if (containerRequestForm) {
            const whatDoYouWantToDoSelect = containerRequestForm.querySelector('#what_do_you_want_to_do');
            const dataFormSection5 = containerRequestForm.querySelector('[data-form-section-5]');
            const containerFormGroups = dataFormSection5.querySelectorAll('[data-name]');
            const postAddressExtraMessageHolder = containerRequestForm.querySelector('#post-address-extra-message-holder');
            const postAddressExtraFieldHolder = containerRequestForm.querySelector('#post-address-extra-field-holder');
            const containerSizesRequiredMessageHolder = containerRequestForm.querySelector('[data-name="specify_containers_required_note"]');

            const $currentGftContainerElement = containerRequestForm.querySelector('[data-name="current_gft_container"]');
            const $desiredGftContainerElement = containerRequestForm.querySelector('[data-name="desired_gft_container"]');
            const $currentRestContainerElement = containerRequestForm.querySelector('[data-name="current_rest_container"]');
            const $desiredRestContainerElement = containerRequestForm.querySelector('[data-name="desired_rest_container"]');

            const $dataFormGroupPayNowElement = containerRequestForm.querySelector('[data-form-group-pay-now]');
            const $payNowMessageElement = $dataFormGroupPayNowElement.querySelector('.message');
            const $payNowAlternativeMessageElement = $dataFormGroupPayNowElement.querySelector('.alternative');
            const $payNowInputElement = $dataFormGroupPayNowElement.querySelector('.pay-now-input');
            const $payNowCheckboxElement = containerRequestForm.querySelector('[name="pay_now"]');
            const $payWithBankTransferElement = containerRequestForm.querySelector('[name="pay_with_bank_transfer"]');
            const $containerFollowUpQuestionSelect = containerRequestForm.querySelector('select[name="is_the_house_new_construction_and_are_there_no_containers_yet"]');
            const $containerDidYouMoveInTheLastTwoMonthsSelect = containerRequestForm.querySelector('select[name="did_you_move_in_the_last_two_months"]');
            const $containerSizeContainer = containerRequestForm.querySelector('select[name="size_container"]');
            const $containerTypeContainer = containerRequestForm.querySelector('select[name="type_container"]');
            let selectedOptionWhatDoYouWant = null;
            const municipality = Cookie.get('municipality');

            whatDoYouWantToDoSelect.addEventListener('change', (event) => {
                // Set the current value of what do you want
                selectedOptionWhatDoYouWant = event.target.value;

                // Hide all field panels first
                containerFormGroups.forEach((el) => {
                    if (!el.classList.contains('form-note')) {
                        el.classList.add('hidden');
                    }
                });

                if (containerRequestForm.querySelector('[data-follow-up-question]') !== null
                    && containerRequestForm.querySelector('[data-section-did-you-move-in-the-last-two-months]') !== null) {
                    containerRequestForm.querySelector('[data-follow-up-question]').classList.add('hidden');
                    containerRequestForm.querySelector('[data-section-did-you-move-in-the-last-two-months]').classList.add('hidden');
                }

                // Show relevant field panels based on selected value
                switch (event.target.value) {
                case 'Wisselen volume van uw huidige container':
                    postAddressExtraMessageHolder.classList.add('hidden');
                    postAddressExtraFieldHolder.classList.add('hidden');
                    containerSizesRequiredMessageHolder.classList.add('hidden');
                    dataFormSection5.classList.remove('hidden');

                    // eslint-disable-next-line max-len,no-use-before-define
                    hidePayNow($payNowMessageElement, null, $payNowAlternativeMessageElement, null, $payNowInputElement, $dataFormGroupPayNowElement);

                    // eslint-disable-next-line no-use-before-define
                    setDesiredContainerFirstOptionText($desiredGftContainerElement, $desiredRestContainerElement, 'Deze hoeft niet gewisseld te worden');
                    $payNowCheckboxElement.checked = false;

                    editDesiredGftContainerOptions(false);
                    editDesiredRestContainerOptions(false);

                    $desiredGftContainerElement.classList.remove('hidden');
                    $currentGftContainerElement.classList.remove('hidden');
                    if (municipality !== 'beesel') {
                        $currentRestContainerElement.classList.remove('hidden');
                        $desiredRestContainerElement.classList.remove('hidden');
                    }

                    if (containerRequestForm.querySelector('[data-name="do_you_want_to_request_a_milieubox"]') !== null) {
                        containerRequestForm.querySelector('[data-name="do_you_want_to_request_a_milieubox"]').classList.remove('hidden');
                    }

                    // eslint-disable-next-line max-len,no-use-before-define
                    containerComparisonCheck($desiredRestContainerElement, $currentRestContainerElement, $payNowMessageElement, $payNowAlternativeMessageElement, $payNowInputElement, $dataFormGroupPayNowElement, $desiredGftContainerElement, $currentGftContainerElement);

                    break;
                case 'Containers aanvragen voor mijn nieuwbouw woning':
                case 'Containers aanvragen voor mijn nieuwe woning':
                    postAddressExtraMessageHolder.classList.add('hidden');
                    postAddressExtraFieldHolder.classList.add('hidden');
                    containerSizesRequiredMessageHolder.classList.remove('hidden');
                    dataFormSection5.classList.remove('hidden');
                    $payNowCheckboxElement.checked = false;

                    editDesiredGftContainerOptions(false);
                    editDesiredRestContainerOptions(false);

                    if ($containerFollowUpQuestionSelect) {
                        if ($containerFollowUpQuestionSelect.value !== undefined && $containerFollowUpQuestionSelect.value !== null && $containerFollowUpQuestionSelect.value !== '') {
                            if ($containerFollowUpQuestionSelect.value === 'Ja') {
                                containerRequestForm.querySelector('[data-section-did-you-move-in-the-last-two-months]').classList.remove('hidden');
                                containerSizesRequiredMessageHolder.classList.add('hidden');
                                if (municipality !== 'beesel') {
                                    $currentRestContainerElement.classList.remove('hidden');
                                }
                                $currentGftContainerElement.classList.remove('hidden');
                                // eslint-disable-next-line no-use-before-define
                                hidePayNow($payNowMessageElement, 'Uw aanvraag voor containers bij nieuwbouw wordt beoordeeld door de gemeente. Zijn er op het adres nog geen containers geleverd? Dan geeft de gemeente RD Maasland de opdracht om deze gratis bij u te bezorgen.\n'
                                    + 'Bent u recent verhuisd? Dan kunt u binnen twee maanden na uw verhuizing gratis een wisseling van containers aanvragen.'
                                    + 'Staan er al containers en bent u niet, of langer dan twee maanden geleden verhuisd? Dan kost het wisselen €35,-.'
                                    + 'RD Maasland neemt contact met u op over het wisselen van de containers en de betaling.', $payNowAlternativeMessageElement, null, $payNowInputElement, $dataFormGroupPayNowElement, true);
                            } else {
                                containerSizesRequiredMessageHolder.classList.remove('hidden');
                                $currentRestContainerElement.classList.add('hidden');
                                $currentGftContainerElement.classList.add('hidden');
                                if (municipality === 'beesel') {
                                    containerRequestForm.querySelector('[data-name="desired_rest_container"]').classList.remove('hidden');
                                }
                            }
                        }
                    }

                    if ($containerDidYouMoveInTheLastTwoMonthsSelect) {
                        if ($containerDidYouMoveInTheLastTwoMonthsSelect.value !== undefined && $containerDidYouMoveInTheLastTwoMonthsSelect.value !== null && $containerDidYouMoveInTheLastTwoMonthsSelect.value !== '') {
                            if ($containerDidYouMoveInTheLastTwoMonthsSelect.value === 'Ja') {
                                containerRequestForm.querySelector('[data-name="desired_gft_container"] option:nth-child(1)').innerHTML = 'Deze hoeft niet gewisseld te worden';
                                if (municipality !== 'beesel') {
                                    containerRequestForm.querySelector('[data-name="desired_rest_container"] option:nth-child(1)').innerHTML = 'Deze hoeft niet gewisseld te worden';
                                }
                            } else if ($containerDidYouMoveInTheLastTwoMonthsSelect.value === 'Nee') {
                                // eslint-disable-next-line no-use-before-define
                                showPayNow($payNowMessageElement, 'De ophaalkosten bedragen €35,-. U kunt dit meteen betalen via iDEAL. Indien u hiervoor kiest wordt u doorverwezen naar een betaalpagina.', $payNowAlternativeMessageElement, 'Wilt u betalen via een bankopdracht? Maak dan het bovenvermelde bedrag over op NL82 RABO 0104 8064 00 ten name van Gem.Reg. RD Maasland onder vermelding van uw POSTCODE en HUISNUMMER. Zodra de betaling ontvangen is, nemen we uw aanvraag in behandeling.', $payNowInputElement, $dataFormGroupPayNowElement);
                            }
                        }
                    }

                    // eslint-disable-next-line no-use-before-define,no-useless-concat
                    hidePayNow($payNowMessageElement, 'Uw aanvraag voor containers bij nieuwbouw wordt beoordeeld door de gemeente. Zijn er op het adres nog geen containers geleverd? Dan geeft de gemeente RD Maasland de opdracht om deze gratis bij u te bezorgen.\n'
                        + 'Bent u recent verhuisd? Dan kunt u binnen twee maanden na uw verhuizing gratis een wisseling van containers aanvragen.'
                        + 'Staan er al containers en bent u niet, of langer dan twee maanden geleden verhuisd? Dan kost het wisselen €35,-.'
                        + 'RD Maasland neemt contact met u op over het wisselen van de containers en de betaling.', $payNowAlternativeMessageElement, null, $payNowInputElement, $dataFormGroupPayNowElement, true);
                    // eslint-disable-next-line no-use-before-define
                    setDesiredContainerFirstOptionText($desiredGftContainerElement, $desiredRestContainerElement, 'Kies het volume van uw container');

                    containerRequestForm.querySelector('[data-name="desired_gft_container"]').classList.remove('hidden');
                    if (municipality !== 'beesel') {
                        containerRequestForm.querySelector('[data-name="desired_rest_container"]').classList.remove('hidden');
                    }
                    if (containerRequestForm.querySelector('[data-name="do_you_want_to_request_a_milieubox"]') !== null) {
                        containerRequestForm.querySelector('[data-name="do_you_want_to_request_a_milieubox"]').classList.remove('hidden');
                    }
                    containerRequestForm.querySelector('[data-name="desired_delivery_date"]').classList.remove('hidden');
                    if (containerRequestForm.querySelector('[data-follow-up-question]') !== null) {
                        containerRequestForm.querySelector('[data-follow-up-question]').classList.remove('hidden');
                    }
                    break;
                case 'Een reparatie van een container aanvragen':
                    postAddressExtraMessageHolder.classList.add('hidden');
                    postAddressExtraFieldHolder.classList.add('hidden');
                    containerSizesRequiredMessageHolder.classList.add('hidden');
                    dataFormSection5.classList.remove('hidden');
                    $payNowCheckboxElement.checked = false;

                    // eslint-disable-next-line max-len,no-use-before-define
                    hidePayNow($payNowMessageElement, null, $payNowAlternativeMessageElement, null, $payNowInputElement, $dataFormGroupPayNowElement);
                    if (municipality === 'beesel') {
                        $containerSizeContainer.disabled = true;
                        // eslint-disable-next-line no-use-before-define
                        swapContainerValues();
                        // eslint-disable-next-line no-use-before-define
                        toggleContainerOptions(false);
                    }

                    containerRequestForm.querySelector('[data-name="damage_container"]').classList.remove('hidden');
                    containerRequestForm.querySelector('[data-name="type_container"]').classList.remove('hidden');
                    containerRequestForm.querySelector('[data-name="size_container"]').classList.remove('hidden');
                    containerRequestForm.querySelector('[data-name="description_damage"]').classList.remove('hidden');
                    break;
                case 'Mijn GFT en REST container laten ophalen (alleen mogelijk bij bedrijf aan huis)':
                    postAddressExtraMessageHolder.classList.remove('hidden');
                    postAddressExtraFieldHolder.classList.remove('hidden');
                    containerSizesRequiredMessageHolder.classList.add('hidden');
                    dataFormSection5.classList.remove('hidden');
                    $payNowCheckboxElement.checked = false;

                    // eslint-disable-next-line no-use-before-define
                    showPayNow($payNowMessageElement, 'De ophaalkosten bedragen €35,-. U kunt dit meteen betalen via iDEAL. Indien u hiervoor kiest wordt u doorverwezen naar een betaalpagina.', $payNowAlternativeMessageElement, 'Wilt u betalen via een bankopdracht? Maak dan het bovenvermelde bedrag over op NL82 RABO 0104 8064 00 ten name van Gem.Reg. RD Maasland onder vermelding van uw POSTCODE en HUISNUMMER. Zodra de betaling ontvangen is, nemen we uw aanvraag in behandeling.', $payNowInputElement, $dataFormGroupPayNowElement);

                    break;
                case 'Laten ophalen tweede GFT container':
                    postAddressExtraMessageHolder.classList.add('hidden');
                    postAddressExtraFieldHolder.classList.add('hidden');
                    containerSizesRequiredMessageHolder.classList.add('hidden');
                    dataFormSection5.classList.add('hidden');
                    $payNowCheckboxElement.checked = false;

                    // eslint-disable-next-line no-use-before-define
                    showPayNow($payNowMessageElement, 'De inleverkosten voor een tweede GFT-container bedragen €35,-. U kunt dit meteen betalen via iDEAL. Indien u hiervoor kiest wordt u doorverwezen naar een betaalpagina.', $payNowAlternativeMessageElement, 'Wilt u betalen via een bankopdracht? Maak dan het bovenvermelde bedrag over op NL82 RABO 0104 8064 00 ten name van Gem.Reg. RD Maasland onder vermelding van uw POSTCODE en HUISNUMMER. Zodra de betaling ontvangen is, nemen we uw aanvraag in behandeling.', $payNowInputElement, $dataFormGroupPayNowElement);

                    break;
                case 'Laten ophalen tweede REST container':
                    postAddressExtraMessageHolder.classList.add('hidden');
                    postAddressExtraFieldHolder.classList.add('hidden');
                    containerSizesRequiredMessageHolder.classList.add('hidden');
                    dataFormSection5.classList.add('hidden');
                    $payNowCheckboxElement.checked = false;

                    // eslint-disable-next-line no-use-before-define,max-len
                    hidePayNow($payNowMessageElement, null, $payNowAlternativeMessageElement, null, $payNowInputElement, $dataFormGroupPayNowElement);

                    break;
                case 'Container vervangen i.v.m. brandschade of diefstal':
                    postAddressExtraMessageHolder.classList.add('hidden');
                    postAddressExtraFieldHolder.classList.add('hidden');
                    containerSizesRequiredMessageHolder.classList.add('hidden');
                    dataFormSection5.classList.remove('hidden');
                    $payNowCheckboxElement.checked = false;

                    // eslint-disable-next-line max-len,no-use-before-define
                    hidePayNow($payNowMessageElement, null, $payNowAlternativeMessageElement, null, $payNowInputElement, $dataFormGroupPayNowElement);
                    if (municipality === 'beesel') {
                        $containerSizeContainer.disabled = true;
                        // eslint-disable-next-line no-use-before-define
                        swapContainerValues();
                    }

                    containerRequestForm.querySelector('[data-name="fire_damage_or_robbery"]').classList.remove('hidden');
                    containerRequestForm.querySelector('[data-name="type_container"]').classList.remove('hidden');
                    containerRequestForm.querySelector('[data-name="size_container"]').classList.remove('hidden');
                    break;
                case 'Een tweede GFT container aanvragen':
                    postAddressExtraMessageHolder.classList.add('hidden');
                    postAddressExtraFieldHolder.classList.add('hidden');
                    containerSizesRequiredMessageHolder.classList.add('hidden');
                    dataFormSection5.classList.remove('hidden');
                    $payNowCheckboxElement.checked = false;

                    editCurrentRestContainerOptions(false);
                    editDesiredGftContainerOptions(true);

                    // eslint-disable-next-line no-use-before-define
                    showPayNow($payNowMessageElement, 'De leveringskosten voor een tweede GFT-container bedragen €35,-. U kunt dit meteen betalen via iDEAL. Indien u hiervoor kiest wordt u doorverwezen naar een betaalpagina.', $payNowAlternativeMessageElement, 'Wilt u betalen via een bankopdracht? Maak dan het bovenvermelde bedrag over op NL82 RABO 0104 8064 00 ten name van Gem.Reg. RD Maasland onder vermelding van uw POSTCODE en HUISNUMMER. Zodra de betaling ontvangen is, nemen we uw aanvraag in behandeling.', $payNowInputElement, $dataFormGroupPayNowElement);

                    containerRequestForm.querySelector('[data-name="desired_gft_container"]').classList.remove('hidden');
                    break;
                case 'Aanvragen extra restafval container in geval van medische indicatie':
                    postAddressExtraMessageHolder.classList.add('hidden');
                    postAddressExtraFieldHolder.classList.add('hidden');
                    containerSizesRequiredMessageHolder.classList.add('hidden');
                    dataFormSection5.classList.remove('hidden');
                    $payNowCheckboxElement.checked = false;

                    // eslint-disable-next-line max-len,no-use-before-define
                    hidePayNow($payNowMessageElement, null, $payNowAlternativeMessageElement, null, $payNowInputElement, $dataFormGroupPayNowElement);

                    editCurrentRestContainerOptions(false);
                    if (municipality === 'beesel') {
                        editDesiredRestContainerOptions(false);
                    } else {
                        containerRequestForm.querySelector('[data-name="desired_rest_container"]').classList.remove('hidden');
                        editDesiredRestContainerOptions(true);
                    }
                    editDesiredRestContainerOptions(true);

                    containerRequestForm.querySelector('[data-name="medical_indication"]').classList.remove('hidden');
                    containerRequestForm.querySelector('[data-name="medical_indication_note"]').classList.remove('hidden');
                    break;
                case 'Wisselen restafvalcontainer naar 240 liter in geval van medische indicatie':
                    postAddressExtraMessageHolder.classList.add('hidden');
                    postAddressExtraFieldHolder.classList.add('hidden');
                    containerSizesRequiredMessageHolder.classList.add('hidden');
                    dataFormSection5.classList.remove('hidden');
                    $payNowCheckboxElement.checked = false;

                    // eslint-disable-next-line max-len,no-use-before-define
                    hidePayNow($payNowMessageElement, null, $payNowAlternativeMessageElement, null, $payNowInputElement, $dataFormGroupPayNowElement);

                    editDesiredRestContainerOptions(true);
                    editCurrentRestContainerOptions(true);

                    containerRequestForm.querySelector('[data-name="current_rest_container"]').classList.remove('hidden');
                    containerRequestForm.querySelector('[data-name="desired_rest_container"]').classList.remove('hidden');
                    break;
                default:
                    postAddressExtraMessageHolder.classList.add('hidden');
                    postAddressExtraFieldHolder.classList.add('hidden');
                    containerSizesRequiredMessageHolder.classList.add('hidden');
                    dataFormSection5.classList.add('hidden');
                    $payNowCheckboxElement.checked = false;

                    break;
                }
            });

            if ($containerFollowUpQuestionSelect) {
                $containerFollowUpQuestionSelect.addEventListener('change', (event) => {
                    switch (event.target.value) {
                    case 'Ja':
                        containerSizesRequiredMessageHolder.classList.add('hidden');
                        if (municipality !== 'beesel') {
                            $currentRestContainerElement.classList.remove('hidden');
                        } else {
                            $desiredRestContainerElement.classList.add('hidden');
                        }
                        $currentGftContainerElement.classList.remove('hidden');
                        toggleContainerOptions(false);
                        containerRequestForm.querySelector('[data-name="desired_gft_container"] option:nth-child(1)').innerHTML = 'Kies het volume van uw container';
                        containerRequestForm.querySelector('[data-name="desired_rest_container"] option:nth-child(1)').innerHTML = 'Kies het volume van uw container';
                        containerRequestForm.querySelector('[data-section-did-you-move-in-the-last-two-months]').classList.remove('hidden');
                        break;
                    case 'Nee':
                        containerSizesRequiredMessageHolder.classList.remove('hidden');
                        $currentRestContainerElement.classList.add('hidden');
                        $currentGftContainerElement.classList.add('hidden');
                        if (municipality === 'beesel') {
                            $desiredRestContainerElement.classList.add('hidden');
                            // eslint-disable-next-line no-use-before-define
                            toggleContainerOptions(true);
                        } else {
                            // eslint-disable-next-line no-use-before-define
                            toggleContainerOptions(false);
                        }
                        containerRequestForm.querySelector('[data-name="desired_gft_container"] option:nth-child(1)').innerHTML = 'Kies het volume van uw container';
                        containerRequestForm.querySelector('[data-name="desired_rest_container"] option:nth-child(1)').innerHTML = 'Kies het volume van uw container';
                        containerRequestForm.querySelector('[data-section-did-you-move-in-the-last-two-months]').classList.add('hidden');
                        break;
                    default:
                        containerRequestForm.querySelector('[data-section-did-you-move-in-the-last-two-months]').classList.remove('hidden');
                        break;
                    }
                });
            }

            if ($containerDidYouMoveInTheLastTwoMonthsSelect) {
                $containerDidYouMoveInTheLastTwoMonthsSelect.addEventListener('change', (event) => {
                    switch (event.target.value) {
                    case 'Ja':
                        $payNowCheckboxElement.checked = false;
                        // eslint-disable-next-line max-len,no-use-before-define
                        hidePayNow($payNowMessageElement, null, $payNowAlternativeMessageElement, null, $payNowInputElement, $dataFormGroupPayNowElement);
                        containerRequestForm.querySelector('[data-name="desired_gft_container"] option:nth-child(1)').innerHTML = 'Deze hoeft niet gewisseld te worden';
                        containerRequestForm.querySelector('[data-name="desired_rest_container"] option:nth-child(1)').innerHTML = 'Deze hoeft niet gewisseld te worden';
                        containerRequestForm.querySelector('[data-name="current_gft_container"] option:nth-child(1)').innerHTML = 'Deze hoeft niet gewisseld te worden';
                        containerRequestForm.querySelector('[data-name="current_rest_container"] option:nth-child(1)').innerHTML = 'Deze hoeft niet gewisseld te worden';
                        break;
                    case 'Nee':
                        $payNowCheckboxElement.checked = false;
                        // eslint-disable-next-line no-use-before-define
                        showPayNow($payNowMessageElement, 'De ophaalkosten bedragen €35,-. U kunt dit meteen betalen via iDEAL. Indien u hiervoor kiest wordt u doorverwezen naar een betaalpagina.', $payNowAlternativeMessageElement, 'Wilt u betalen via een bankopdracht? Maak dan het bovenvermelde bedrag over op NL82 RABO 0104 8064 00 ten name van Gem.Reg. RD Maasland onder vermelding van uw POSTCODE en HUISNUMMER. Zodra de betaling ontvangen is, nemen we uw aanvraag in behandeling.', $payNowInputElement, $dataFormGroupPayNowElement);
                        containerRequestForm.querySelector('[data-name="desired_gft_container"] option:nth-child(1)').innerHTML = 'Kies het volume van uw container';
                        containerRequestForm.querySelector('[data-name="desired_rest_container"] option:nth-child(1)').innerHTML = 'Kies het volume van uw container';
                        containerRequestForm.querySelector('[data-name="current_gft_container"] option:nth-child(1)').innerHTML = 'Kies het volume van uw container';
                        containerRequestForm.querySelector('[data-name="current_rest_container"] option:nth-child(1)').innerHTML = 'Kies het volume van uw container';
                        break;
                    default:
                        $payNowCheckboxElement.checked = false;
                        // eslint-disable-next-line max-len
                        hidePayNow($payNowMessageElement, null, $payNowAlternativeMessageElement, null, $payNowInputElement, $dataFormGroupPayNowElement);
                        containerRequestForm.querySelector('[data-name="desired_gft_container"] option:nth-child(1)').innerHTML = 'Kies het volume van uw container';
                        containerRequestForm.querySelector('[data-name="desired_rest_container"] option:nth-child(1)').innerHTML = 'Kies het volume van uw container';
                        containerRequestForm.querySelector('[data-name="current_gft_container"] option:nth-child(1)').innerHTML = 'Kies het volume van uw container';
                        containerRequestForm.querySelector('[data-name="current_rest_container"] option:nth-child(1)').innerHTML = 'Kies het volume van uw container';
                        break;
                    }
                });
            }

            const containerAddressEqualsAddressSelect = containerRequestForm.querySelector('select[name="container_addresss_equals_address"]');
            containerAddressEqualsAddressSelect.addEventListener('change', (event) => {
                switch (event.target.value) {
                case '0':
                    containerRequestForm.querySelector('[data-form-section-4]').classList.remove('hidden');
                    break;
                default:
                    containerRequestForm.querySelector('[data-form-section-4]').classList.add('hidden');
                    break;
                }
            });

            const medicalIndicationSelect = containerRequestForm.querySelector('select[name="medical_indication"]');
            if (medicalIndicationSelect) {
                medicalIndicationSelect.addEventListener('change', (event) => {
                    switch (event.target.value) {
                    case '0':
                        containerRequestForm.querySelector('[data-name="medical_indication_note"]').classList.add('hidden');
                        break;
                    default:
                        containerRequestForm.querySelector('[data-name="medical_indication_note"]').classList.remove('hidden');
                        break;
                    }
                });
            }

            // Scroll to form when form has errors
            const containerRequestFormErrors = containerRequestForm.querySelectorAll('.text-danger').length;
            if (containerRequestFormErrors > 0) {
                containerRequestForm.scrollIntoView();
            }

            // eslint-disable-next-line max-len
            // Trigger change when "What do you want to do field" is set (in case validation fails and user is redirected back to form)
            if (whatDoYouWantToDoSelect.value) {
                whatDoYouWantToDoSelect.dispatchEvent(new Event('change'));
            }

            /**
             *
             * Functions
             *
             */

            /**
             * Toggles the available options in a container selection element based.
             *
             * @param {boolean} only80
             * @return {void} This function does not return a value.
             */
            // eslint-disable-next-line no-inner-declarations
            function toggleContainerOptions(only80 = false) {
                // const desiredContainer = containerRequestForm.querySelector('[data-name="desired_rest_container"]');
                // if (!desiredContainer) return;
                //
                // const select = desiredContainer.querySelector('select');
                // if (!select) return;
                //
                // if (only80) {
                //     // Hide all existing options
                //     // eslint-disable-next-line no-return-assign
                //     Array.from(select.options).forEach((opt) => opt.hidden = true);
                //
                //     // Check if "80 liter" option already exists
                //     let option80 = Array.from(select.options).find((opt) => opt.value === '80 liter');
                //     if (!option80) {
                //         option80 = document.createElement('option');
                //         option80.value = '80 liter';
                //         option80.textContent = '80 liter';
                //         select.appendChild(option80);
                //     }
                //
                //     option80.hidden = false;
                //     option80.selected = true;
                // } else {
                //     // Remove the temporary "80 liter" option if it was added
                //     const option80 = Array.from(select.options).find((opt) => opt.value === '80 liter');
                //     if (option80 && !option80.dataset.default) {
                //         option80.remove();
                //     }
                //
                //     // Show all default options again
                //     // eslint-disable-next-line no-return-assign,no-param-reassign
                //     Array.from(select.options).forEach((opt) => opt.hidden = false);
                // }
            }

            // Function for showing show pay with supplied messages
            // eslint-disable-next-line max-len,no-inner-declarations,no-shadow
            function showPayNow($payNowMessageElement, message, $payNowAlternativeMessageElement, alternative, $payNowInputElement, $dataFormGroupPayNowElement) {
                setTimeout(() => {
                    $payNowMessageElement.innerHTML = message;
                    // eslint-disable-next-line no-param-reassign
                    $payNowAlternativeMessageElement.innerHTML = alternative;
                    $payNowInputElement.classList.remove('hidden');
                    $dataFormGroupPayNowElement.classList.remove('hidden');
                    $payWithBankTransferElement.value = 1;
                }, 0);
            }

            // Function for hiding show pay
            // eslint-disable-next-line max-len,no-inner-declarations,no-shadow
            function hidePayNow($payNowMessageElement, message, $payNowAlternativeMessageElement, alternative, $payNowInputElement, $dataFormGroupPayNowElement, showMessage = false) {
                // eslint-disable-next-line no-param-reassign
                $payNowMessageElement.innerHTML = message;
                // eslint-disable-next-line no-param-reassign
                $payNowAlternativeMessageElement.innerHTML = alternative;
                $payNowInputElement.classList.add('hidden');
                if (!showMessage) {
                    $dataFormGroupPayNowElement.classList.add('hidden');
                }
                $payWithBankTransferElement.value = 0;
            }

            // eslint-disable-next-line max-len,no-inner-declarations,no-shadow
            function containerComparisonCheck($desiredRestContainerElement, $currentRestContainerElement, $payNowMessageElement, $payNowAlternativeMessageElement, $payNowInputElement, $dataFormGroupPayNowElement, $desiredGftContainerElement, $currentGftContainerElement) {
                const currentRestContainerValue = $currentRestContainerElement.querySelector('[name="current_rest_container"]').value;
                const desiredRestContainerValue = $desiredRestContainerElement.querySelector('[name="desired_rest_container"]').value;
                const currentGftContainerValue = $currentGftContainerElement.querySelector('[name="current_gft_container"]').value;
                const desiredGftContainerValue = $desiredGftContainerElement.querySelector('[name="desired_gft_container"]').value;

                // eslint-disable-next-line no-use-before-define
                compareContainerValues(
                    currentRestContainerValue,
                    desiredRestContainerValue,
                    currentGftContainerValue,
                    desiredGftContainerValue,
                    $payNowMessageElement,
                    $payNowAlternativeMessageElement,
                    $payNowInputElement,
                    $dataFormGroupPayNowElement,
                );

                $currentRestContainerElement
                    .addEventListener('change', (event) => {
                        // eslint-disable-next-line max-len,no-use-before-define
                        compareContainerValues(
                            event.target.value,
                            $desiredRestContainerElement.querySelector('[name="desired_rest_container"]').value,
                            $currentGftContainerElement.querySelector('[name="current_gft_container"]').value,
                            $desiredGftContainerElement.querySelector('[name="desired_gft_container"]').value,
                            $payNowMessageElement,
                            $payNowAlternativeMessageElement,
                            $payNowInputElement,
                            $dataFormGroupPayNowElement,
                        );
                    });

                $desiredRestContainerElement
                    .addEventListener('change', (event) => {
                        // eslint-disable-next-line max-len,no-use-before-define
                        compareContainerValues(
                            $currentRestContainerElement.querySelector('[name="current_rest_container"]').value,
                            event.target.value,
                            $currentGftContainerElement.querySelector('[name="current_gft_container"]').value,
                            $desiredGftContainerElement.querySelector('[name="desired_gft_container"]').value,
                            $payNowMessageElement,
                            $payNowAlternativeMessageElement,
                            $payNowInputElement,
                            $dataFormGroupPayNowElement,
                        );
                    });

                $currentGftContainerElement
                    .addEventListener('change', (event) => {
                        // eslint-disable-next-line max-len,no-use-before-define
                        compareContainerValues(
                            $currentRestContainerElement.querySelector('[name="current_rest_container"]').value,
                            $desiredRestContainerElement.querySelector('[name="desired_rest_container"]').value,
                            event.target.value,
                            $desiredGftContainerElement.querySelector('[name="desired_gft_container"]').value,
                            $payNowMessageElement,
                            $payNowAlternativeMessageElement,
                            $payNowInputElement,
                            $dataFormGroupPayNowElement,
                        );
                    });

                $desiredGftContainerElement
                    .addEventListener('change', (event) => {
                        // eslint-disable-next-line max-len,no-use-before-define
                        compareContainerValues(
                            $currentRestContainerElement.querySelector('[name="current_rest_container"]').value,
                            $desiredRestContainerElement.querySelector('[name="desired_rest_container"]').value,
                            $currentGftContainerElement.querySelector('[name="current_gft_container"]').value,
                            event.target.value,
                            $payNowMessageElement,
                            $payNowAlternativeMessageElement,
                            $payNowInputElement,
                            $dataFormGroupPayNowElement,
                        );
                    });
            }

            // eslint-disable-next-line max-len,no-inner-declarations,no-shadow
            function setDesiredContainerFirstOptionText($desiredGftContainerElement, $desiredRestContainerElement, text) {
                // eslint-disable-next-line no-param-reassign
                $desiredGftContainerElement.querySelector('select[name="desired_gft_container"]').options[0].text = text;
                // eslint-disable-next-line no-param-reassign
                $desiredRestContainerElement.querySelector('select[name="desired_rest_container"]').options[0].text = text;
            }

            function parseContainerValue(value) {
                return value === 'Onbekend' ? value : +value.replace(/ liter/g, '');
            }

            // eslint-disable-next-line no-inner-declarations
            function swapContainerValues() {
                const baseContainerValues = {
                    'Restafval (grijze container)': {
                        '25 liter': '25 liter',
                        '60 liter': '60 liter',
                        '140 liter': '140 liter',
                    },
                    'GFT-afval (groene container)': {
                        '25 liter': '25 liter',
                        '60 liter': '60 liter',
                        '140 liter': '140 liter',
                        '240 liter': '240 liter',
                    },
                };

                $containerTypeContainer.addEventListener('change', (e) => {
                    $containerSizeContainer.disabled = false;
                    $containerSizeContainer.innerHTML = '<option value="" disabled selected>Selecteer een afmeting</option>';

                    let containerValues = baseContainerValues[e.target.value];
                    if (municipality === 'beesel' && $containerTypeContainer.value === 'Restafval (grijze container)') {
                        containerValues = {
                            '25 liter': '25 liter',
                            '80 liter': '80 liter',
                        };
                    }

                    Object.keys(containerValues).forEach((key) => {
                        const option = document.createElement('option');
                        option.value = containerValues[key];
                        option.text = key;
                        $containerSizeContainer.appendChild(option);
                    });
                });
            }

            // eslint-disable-next-line no-inner-declarations
            function compareContainerValues(
                currentRestValue,
                desiredRestValue,
                currentGftValue,
                desiredGftValue,
                $payNowMessageElement,
                $payNowAlternativeMessageElement,
                $payNowInputElement,
                $dataFormGroupPayNowElement,
            ) {
                const messageRest = $desiredRestContainerElement.getAttribute('data-message');
                const alternativeRest = $desiredRestContainerElement.getAttribute('data-alternative-message');
                const messageGft = $desiredGftContainerElement.getAttribute('data-message');
                const alternativeGft = $desiredGftContainerElement.getAttribute('data-alternative-message');

                const parsedCurrentRestValue = parseContainerValue(currentRestValue);
                const parsedDesiredRestValue = parseContainerValue(desiredRestValue);
                const parsedCurrentGftValue = parseContainerValue(currentGftValue);
                const parsedDesiredGftValue = parseContainerValue(desiredGftValue);

                const containers = [
                    {
                        type: 'REST', current: parsedCurrentRestValue, desired: parsedDesiredRestValue, message: messageRest, alternative: alternativeRest,
                    },
                    {
                        type: 'GFT', current: parsedCurrentGftValue, desired: parsedDesiredGftValue, message: messageGft, alternative: alternativeGft,
                    },
                ];

                let shouldShowPayNow = false;
                let message;
                let alternative;
                let stopLoop = false;

                for (const container of containers) {
                    if (container.current !== 0 && container.desired !== 0 && stopLoop === false) {
                        // If the current container status is 'Onbekend' (Unknown), show the Pay Now option
                        if (container.current === 'Onbekend') {
                            shouldShowPayNow = true;
                            message = container.message;
                            alternative = container.alternative;
                            break;
                        }

                        // If the container type is 'REST' and the desired size is greater than the current size, show Pay Now option
                        if (container.type === 'REST' && container.desired > container.current) {
                            shouldShowPayNow = true;
                            message = container.message;
                            alternative = container.alternative;
                        }

                        // If the container type is 'REST' and the desired size is smaller than the current size, hide Pay Now option
                        if (container.type === 'REST' && container.desired < container.current) {
                            shouldShowPayNow = false;
                        }

                        // If the container type is 'GFT' and the desired size differs from the current size, show Pay Now option
                        if (container.type === 'GFT' && container.desired !== container.current) {
                            shouldShowPayNow = true;
                            message = container.message;
                            alternative = container.alternative;
                        }

                        if (municipality === 'roerdalen') {
                            // eslint-disable-next-line max-len
                            // For GFT containers in Roerdalen, allow a free swap if the desired size exceeds the current size.
                            if (container.type === 'GFT'
                                && container.desired > container.current

                            ) {
                                shouldShowPayNow = false;
                            }

                            // For REST containers in Roerdalen, allow a free swap if the desired size is smaller the current size.
                            if (container.type === 'REST') {
                                if (container.desired < container.current) {
                                    shouldShowPayNow = false;
                                    stopLoop = true;
                                } else {
                                    shouldShowPayNow = true;
                                    stopLoop = true;
                                }
                            }
                        }
                    }
                }

                if (selectedOptionWhatDoYouWant === 'Containers aanvragen voor mijn nieuwbouw woning' && municipality === 'beesel') {
                    hidePayNow(
                        $payNowMessageElement,
                        null,
                        $payNowAlternativeMessageElement,
                        null,
                        $payNowInputElement,
                        $dataFormGroupPayNowElement,
                    );
                } else if (shouldShowPayNow) {
                    showPayNow(
                        $payNowMessageElement,
                        message,
                        $payNowAlternativeMessageElement,
                        alternative,
                        $payNowInputElement,
                        $dataFormGroupPayNowElement,
                    );
                } else {
                    hidePayNow(
                        $payNowMessageElement,
                        null,
                        $payNowAlternativeMessageElement,
                        null,
                        $payNowInputElement,
                        $dataFormGroupPayNowElement,
                    );
                }
            }
        }
    });
}
